/**
 * Estado del aviso de minimo de unidades por lista (hoy: PRECIO VOLUMEN).
 *
 * El servidor es quien bloquea; esto solo adelanta el aviso en pantalla con
 * la misma regla:
 *   - cotizacion: cuentan las unidades CUBIERTAS por stock (min(cantidad, stock))
 *   - pedido: cuentan las unidades del pedido
 * `rule` es la respuesta de GET /api/price-list-unit-rule.
 */

/** Categoria sin inventario: cuenta completa, igual que en el servidor. */
export const CATEGORIA_SIN_STOCK = 'Servicios'

/** Unidades de una cotizacion cubiertas por stock. Stock desconocido: decide el servidor. */
export function coveredUnits(lines) {
  return (lines || []).reduce((total, line) => {
    const qty = Number(line.cantidad) || 0
    if (line.categoria === CATEGORIA_SIN_STOCK) return total + qty
    if (line.stock === null || line.stock === undefined) return total + qty
    return total + Math.min(qty, Math.max(0, Number(line.stock) || 0))
  }, 0)
}

export function orderUnits(lines) {
  return (lines || []).reduce((total, line) => total + (Number(line.cantidad) || 0), 0)
}

/**
 * @returns {{ applies: boolean, ok: boolean, min?: number, units?: number, missing?: number, text?: string }}
 */
export function unitRuleStatus(rule, units, documento = 'pedido') {
  if (!rule || !rule.applies) return { applies: false, ok: true }

  const unidades = Number(units) || 0
  const ok = unidades >= rule.min
  const tipo = rule.first ? 'primera compra' : 'compras siguientes'
  const cuenta = documento === 'cotizacion' ? 'con stock disponible' : 'en el pedido'

  const text = ok
    ? `${rule.list}: ${tipo}, mínimo ${rule.min} unidades. Llevas ${unidades} ${cuenta}: cumple.`
    : `No cumple con los criterios para utilizar la lista de precios ${rule.list}: `
      + `${tipo}, mínimo ${rule.min} unidades y llevas ${unidades} ${cuenta} (faltan ${rule.min - unidades}). `
      + 'Se recomienda cambiar a la lista PRECIO REGULAR.'

  return {
    applies: true,
    ok,
    min: rule.min,
    units: unidades,
    missing: Math.max(0, rule.min - unidades),
    text,
  }
}
